import { useTheme } from '../context/ThemeContext';
import PieChartCircle from './PieChartCircle';

const data = [
  { name: 'Direct', value: 300.56 },
  { name: 'Affliate', value: 135.18 },
  { name: 'Sponsored', value: 154.02 },
  { name: 'E-mail', value: 48.96 },
];
const COLORS = ['#1c1c1c', '#baedbd', '#95a4fc', '#b1e3ff'];

export default function TotalSales() {
    const { theme } = useTheme();

    return (
        <div className={` ${theme === '#1c1c1c' ? 'bg-[#282828]' : 'bg-[#f7f9fb]'} App p-6 w-[202px] h-[344px] rounded-xl hover:scale-105 transition-transform`}>
            <div className='text-sm my-bold'>Total Sales</div>
            <PieChartCircle />
            <div className='text-center mt-2'>
                {data.map((entry, index) => (
                    <div key={`item-${entry.name}`} className='flex items-center justify-between gap-4 text-sm my-1 mb-4'>
                        <div>
                        <span
                            className="inline-block w-2 h-2 rounded-full"
                            style={{ backgroundColor: COLORS[index % COLORS.length] }}
                        ></span>
                        <span className='pl-1'>{entry.name}</span>
                        </div>
                        <span className='text-sm'>${entry.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
